import { Directive, ElementRef, HostBinding, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { AccessibilityUtil } from '../accessibility.util';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'img:not([alt]), img[ada-decorative]'
})
export class AccessibleImagesDirective implements OnInit {

	@HostBinding('style') private style: SafeStyle;
	@HostBinding('attr.alt') private alt: string;
	@HostBinding('attr.role') private role: string;

	constructor(
		private sanitizer: DomSanitizer,
		private elementRef: ElementRef
	) { }

	public ngOnInit(): void {
		if ('ada-decorative' in this.elementRef.nativeElement.attributes) {
			// If the image is a decorative image
			this.alt = '';
			this.role = 'presentation';
			this.style = AccessibilityUtil.getDebugStyle(this.sanitizer, 'blue');
		} else {
			// If there is no alt text present
			this.style = AccessibilityUtil.getDebugStyle(this.sanitizer, 'red');
		}
	}

}
